// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditStep_deleteButton__EiWg+","field":"EditStep_field__6oIHi","select":"EditStep_select__zMKn0","text":"EditStep_text__er-XC"};